export default ngModule => {

  ngModule.controller('ComparatorStep1Ctrl', function (
    AonApplicationService,
    AonConfig,
    application,
    $state,
    $scope) {
    
    // Track page navigation
    AonApplicationService.trackEvent(AonConfig.jsConstants.TrackingEvents.NeedsAnalysis);

    this.formChoices = AonConfig.formChoices;
    this.corporate = AonConfig.corporate;
    this.deployment = AonConfig.deployment;
    this.application = application;

    // Ensure age is integral
    this.onAgeChange = (model) => {
      if (model.age) {
        model.age = parseInt(model.age);
      }
    };

    // If only one option for cover type, select it by default
    if (this.formChoices.cover_type.length == 1) {
      this.application.policy.cover_type = this.formChoices.cover_type[0][0];
    }

    this.rebate_tier_choices = AonApplicationService.getRebateTierChoices(application);

    // Only offer to enter the competition first time through, as user can go back
    // from step 2 and change their details
    this.offerCompetition = this.corporate.competition_is_active &&
        !AonApplicationService.getCompetitionHasOpted();

    this.onMembershipTypeChange = () => {
      this.rebate_tier_choices = AonApplicationService.getRebateTierChoices(application);
      let text = AonApplicationService.getRebateTierText(application);
      this.rebate_tier_caption = text.caption;
      this.rebate_tier_description = text.description;
    };

    this.onMembershipTypeChange();

    $scope.$parent.ctrl.scrollToId('step-progress-header', 100);

    /**
     * Save the applicant changes
     */
    this.onSubmit = function(form) {
      this.hasSubmitted = false;
      if (form.$valid) {
        // TODO: Server side validation
        AonApplicationService.saveApplication(this.application);

        if (this.offerCompetition) {
            if (this.application.enter_competition) {
              // TODO(cal): send comp info to aon
              AonApplicationService.setCompetitionOptIn(); // flag as opted in, to avoid re-showing
            } else {
              AonApplicationService.setCompetitionOptOut(); // flag as opted out, to avoid re-showing
            }
        }
        $state.transitionTo('comparator.step2');
      } else {
        if (form.focusInvalid) {
          form.focusInvalid();
        }
        this.hasSubmitted = true;
      }
    };

    // Should be a better way
    let tcs = $("<span>" + this.corporate.terms_and_conditions_brief + "</span>");
    tcs.find("a").click( () => {
      $("div.modal").modal("show");
    });
    $("span#terms_and_conditions").html(tcs);

    this.hasAnsweredCurrentFund = () => {
      const has_previous_fund = _.get(this.application, 'personal.previous_fund.has_previous_fund');
      return has_previous_fund === true || has_previous_fund === false;
    }

  });

}



// WEBPACK FOOTER //
// ./src/controllers/comparator/step1-ctrl.js